import i18n from '@/i18n'

export const getAltTextAndTitleForProduct = product => {
  const title = `${product.product.name} ${product.sort.name} – ${product.country.name}`

  return {
    alt: `${title}, ${product.category.name.toLowerCase()} ${product.caliber ? `размера ${product.caliber}` : ''}`,
    title: `${title}, ${product.category.name.toLowerCase()}, ${product.packing.name.toLowerCase()} ${
      product.weight
    } ${i18n.t(`units.weight.${product.wt_unit.name}`)}`,
  }
}
